import { getBenchRegistryClient } from "@/lib/clients";
import { queryClient } from "@/lib/query-client";
import { useQuery } from "@tanstack/react-query";
import { BenchStateSmall } from "@myth-finance/bench-sdk";
import { calculateBenchState } from "@/lib/utils";

export const queryKeyPrefix = "bench-all";

export interface BenchIndexStates {
  open: BenchStateSmall[];
  upcoming: BenchStateSmall[];
  closed: BenchStateSmall[];
}

export const useAllBenchStates = () => {
  return useQuery({
    queryKey: [queryKeyPrefix],
    staleTime: 2 * 60 * 1_000,
    queryFn: async (): Promise<BenchIndexStates> => {
      console.log("Fetching all bench states");
      const sdk = getBenchRegistryClient();
      try {
        const statesMap = await sdk.getBenchSmallStates();
        const benches = [...statesMap.values()].sort(({ benchId: a }, { benchId: b }) => a > b ? -1 : 1)
        const ret: BenchIndexStates = {
          open: [],
          upcoming: [],
          closed: [],
        };
        for(const bench of benches) {
          const state = calculateBenchState(bench)
          ret[state].push(bench)
        }
        return ret
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
  });
};

export const clearAllBenchCache = (benchId?: bigint) => {
  const queryKey = [queryKeyPrefix];
  if (benchId) queryKey.push(String(benchId));
  queryClient.invalidateQueries({ queryKey });
};
